import { ImagesApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { CORE_API_URL } = process.env;

export default new ImagesApi(CORE_API_URL, {}, olyEngineApi);
